// extracted by mini-css-extract-plugin
module.exports = {"blogPostSocialShare":"style_blogPostSocialShare__Y6COL","shareButton":"style_shareButton__aN5Fq","tooltip":"style_tooltip__Fdj5c g-type-body-small"};